import { useMemo } from 'react';
import { useTranslate } from '@refinedev/core';
import { Card, Flex, theme } from 'antd';
import type { UserOut } from '@/api/generated/schemas';
import { CustomerEntitlementsTable } from '@/components/monetization/customers/CustomerEntitlementsTable';

// The entitlements endpoint filters by a single account, so one card each.
export const UserEntitlementsTab = ({ record }: { record: UserOut }) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const accountIds = useMemo(
    () => Array.from(new Set((record.profiles ?? []).map((p) => p.account_id))),
    [record.profiles]
  );
  const title = t('iam.users.tabs.entitlements');

  if (accountIds.length === 0) {
    return <Card title={title}>{t('messages.no_data')}</Card>;
  }

  return (
    <Flex vertical gap={token.margin}>
      {accountIds.map((accountId) => (
        <Card
          key={accountId}
          title={
            accountIds.length > 1
              ? `${title} · ${t('iam.users.profile_fields.account_id')} ${accountId}`
              : title
          }
        >
          <CustomerEntitlementsTable accountId={accountId} />
        </Card>
      ))}
    </Flex>
  );
};
